import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-autosave-error-dialog',
    templateUrl: './autosave-error-dialog.component.html',
    styleUrl: './autosave-error-dialog.component.css',
    standalone: false,
})
export class AutosaveErrorDialogComponent {
    constructor(
        private dialogRef: MatDialogRef<AutosaveErrorDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            mimicName: string;
            shipyardId: string;
            iAPIVesselId: string;
        }
    ) {}

    close() {
        this.dialogRef.close();
    }

    sendReport() {
        if (!navigator.onLine) return;
        this.dialogRef.close(true);
    }

    isOffline(): boolean {
        return !navigator.onLine;
    }
}
